import { CloseOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import * as Draft from 'draft-js';
import * as React from 'react';

import s from './NotificationEditor.module.scss';

/**
 * Тип сущности для плейсхолдера поля в редакторе уведомлений
 */
export const FIELD_PLACEHOLDER_ENTITY = 'FIELD_PLACEHOLDER';

type Props = React.PropsWithChildren<{
  contentState: Draft.ContentState;
  entityKey: string;
  offsetKey: string;
}>;

/**
 * Функция-стратегия для нахождения плейсхолдеров полей в тексте
 */
const fieldPlaceholderStrategy = (
  contentBlock: Draft.ContentBlock,
  callback: (startIndex: number, endIndex: number) => void,
  contentState: Draft.ContentState
) => {
  contentBlock.findEntityRanges((meta) => {
    const entityKey = meta.getEntity();

    if (!entityKey) {
      return false;
    }

    const entityInstance = contentState.getEntity(entityKey);

    return entityInstance.getType() === FIELD_PLACEHOLDER_ENTITY;
  }, callback);
};

const View: React.FC<Props> = ({
  entityKey,
  contentState,
  offsetKey,
  children,
}: Props) => {
  const handleClose = React.useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      if (!entityKey) {
        return;
      }

      const { onRemoveEntity } = contentState.getEntity(entityKey).getData();
      onRemoveEntity?.(entityKey);
    },
    [contentState, entityKey]
  );

  return (
    <Tag color="blue" className={s.fieldTag} data-offset-key={offsetKey}>
      {children}
      <CloseOutlined className={s.closeIcon} onClick={handleClose} />
    </Tag>
  );
};

/**
 * Декоратор для отображения плейсхолдеров полей как тегов
 */
export const FieldPlaceholderDecorator: Draft.DraftDecorator = {
  strategy: fieldPlaceholderStrategy,
  component: View,
};
